(function initGiftModalLoader(global) {
  'use strict';

  if (global.SnowcubesGiftModal) return;

  var loadPromise = null;
  var intentSelector = '[data-gift-note-open], [data-edit-gift]';
  var giftModalLoadError = "We couldn't open the gift-note options. Please try again.";

  function urls() {
    return global.SnowcubesGiftModalAssetUrls || {};
  }

  function isReady() {
    return Boolean(
      global.customElements &&
      global.customElements.get('gift-box-customizer-modal') &&
      typeof global.openGiftBoxModal === 'function'
    );
  }

  function loadStylesheet(url) {
    if (!url) return Promise.reject(new Error('Gift modal stylesheet URL is missing'));

    var existing = document.querySelector('link[data-snowcubes-gift-modal-style]');
    if (existing && existing.dataset.loaded === 'true') return Promise.resolve(existing);

    return new Promise(function (resolve, reject) {
      var link = existing || document.createElement('link');
      var onLoad = function () {
        link.dataset.loaded = 'true';
        resolve(link);
      };
      var onError = function () {
        link.remove();
        reject(new Error('Failed to load gift modal stylesheet'));
      };

      link.addEventListener('load', onLoad, { once: true });
      link.addEventListener('error', onError, { once: true });

      if (!existing) {
        link.rel = 'stylesheet';
        link.href = url;
        link.dataset.snowcubesGiftModalStyle = 'true';
        document.head.appendChild(link);
      }
    });
  }

  function loadScript(key, url, ready) {
    if (typeof ready === 'function' && ready()) return Promise.resolve(null);
    if (!url) return Promise.reject(new Error('Gift modal asset URL is missing: ' + key));

    var selector = 'script[data-snowcubes-gift-modal-script="' + key + '"]';
    var existing = document.querySelector(selector);

    return new Promise(function (resolve, reject) {
      var script = existing || document.createElement('script');
      var onLoad = function () {
        if (typeof ready === 'function' && !ready()) {
          script.remove();
          reject(new Error('Gift modal asset did not initialize: ' + key));
          return;
        }
        resolve(script);
      };
      var onError = function () {
        script.remove();
        reject(new Error('Failed to load gift modal asset: ' + key));
      };

      script.addEventListener('load', onLoad, { once: true });
      script.addEventListener('error', onError, { once: true });

      if (!existing) {
        script.src = url;
        script.async = false;
        script.dataset.snowcubesGiftModalScript = key;
        document.head.appendChild(script);
      }
    });
  }

  function ensureLoaded() {
    if (isReady()) return Promise.resolve(global.SnowcubesGiftModal);
    if (loadPromise) return loadPromise;

    var assetUrls = urls();
    loadPromise = loadStylesheet(assetUrls.stylesheet)
      .then(function () {
        return loadScript('catalog', assetUrls.catalog, function () {
          return Boolean(global.SnowcubesGiftCatalog);
        });
      })
      .then(function () {
        return loadScript('cart', assetUrls.cart, function () {
          return Boolean(global.SnowcubesGiftCart);
        });
      })
      .then(function () {
        return loadScript('modal', assetUrls.modal, function () {
          return Boolean(global.customElements.get('gift-box-customizer-modal'));
        });
      })
      .then(function () {
        return loadScript('wiring', assetUrls.wiring, function () {
          return typeof global.openGiftBoxModal === 'function';
        });
      })
      .then(function () {
        if (!isReady()) throw new Error('Gift modal did not become ready');
        return global.SnowcubesGiftModal;
      })
      .catch(function (error) {
        loadPromise = null;
        throw error;
      });

    return loadPromise;
  }

  function intentTarget(event) {
    return event.target instanceof Element ? event.target.closest(intentSelector) : null;
  }

  function prewarm(event) {
    if (!intentTarget(event) || isReady()) return;
    ensureLoaded().catch(function () {
      // An explicit click gets the visible retry message. Prewarm stays quiet.
    });
  }

  function showLoadError(target) {
    document.querySelectorAll('[data-gift-modal-load-error]').forEach(function (node) {
      node.remove();
    });
    var message = document.createElement('p');
    message.dataset.giftModalLoadError = 'true';
    message.className = 'message-error';
    message.setAttribute('role', 'alert');
    message.textContent = giftModalLoadError;
    target.insertAdjacentElement('afterend', message);
    target.focus();
  }

  function handleClick(event) {
    var target = intentTarget(event);
    if (!target || isReady()) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    target.setAttribute('aria-busy', 'true');

    ensureLoaded()
      .then(function () {
        target.removeAttribute('aria-busy');
        if (target.isConnected) target.click();
      })
      .catch(function () {
        target.removeAttribute('aria-busy');
        if (target.isConnected) showLoadError(target);
      });
  }

  function start() {
    document.addEventListener('pointerover', prewarm, true);
    document.addEventListener('focusin', prewarm, true);
    document.addEventListener('touchstart', prewarm, true);
    document.addEventListener('click', handleClick, true);

    if (new URLSearchParams(global.location.search).get('gift') === '1') {
      ensureLoaded().catch(function () {
        // Deep-link failure is non-mutating; explicit interaction can retry.
      });
    }
  }

  function stop() {
    document.removeEventListener('pointerover', prewarm, true);
    document.removeEventListener('focusin', prewarm, true);
    document.removeEventListener('touchstart', prewarm, true);
    document.removeEventListener('click', handleClick, true);
  }

  var api = {
    ensureLoaded: ensureLoaded,
    isReady: isReady,
    loadScript: loadScript,
    loadStylesheet: loadStylesheet,
    showLoadError: showLoadError,
    stop: stop,
  };
  global.SnowcubesGiftModal = api;

  // The loader itself is deferred, so the document has been parsed. Register
  // capture listeners immediately instead of leaving an interaction gap before
  // DOMContentLoaded.
  start();

  if (typeof module !== 'undefined' && module.exports) module.exports = api;
})(typeof window !== 'undefined' ? window : globalThis);
